
<template>
  <div class="container row">
    <div class="col-12">
      <div class="mt-4 fw-bold col-12 h5">
        האם אתם יודעים מה הם החפצים הנמצאים סביבי?
      </div>
      <div class="my-4 col-12 h6">
לחצו על תמונה של חפץ בעמוד הימני, ולאחרמכן לחצו על המילה המתאימה בעמוד השמאלי.      </div>
    </div>

    <div class="row">
      <div class="image-list">
        <ul class="me-2">
          <li v-for="(image, index) in images" :key="index" @click="selectImage(index, $event)">
            <img :src="image.src" alt="image">
          </li>
        </ul>
      </div>
      <div class="description-lists me-3">
        <div v-for="(item, index) in shuffledItems" :key="index" class="descriptionItems"
          @click="checkSelection(item, $event)">
          {{ item.description }}
        </div>

      </div>
    </div>
    <div class="me-3">
      <div style="font-size: 17px">
        <span class="fw-bold">צפחת</span>
        - כלי עשוי חרס בצורת עדשה. שימש לנוזלים בדומה למימיה
      </div>
      <div style="font-size: 17px">
        <span class="fw-bold">קובעת</span>
        - קערת חרס העומדת על רגל גבוהה - מתגלה בדרך כלל בקברים או במקדשים
      </div>
      <div style="font-size: 17px">
        <span class="fw-bold">קדרה</span> - כלי קיבול ואחסון
        לגרעינים וקמח
      </div>
      <div style="font-size: 17px">
        <span class="fw-bold">טבעת עם עיטור חרפושית</span> -
        טבעת ששימשה כחותם
      </div>
      <div style="font-size: 17px" class="fw-bold">
       קערת חרס
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        { src: require('../../static/img/bague.jpeg'), index: 1 },
        { src: require('../../static/img/bol.jpeg'), index: 2 },
        { src: require('../../static/img/bouteille1.jpeg'), index: 3 },
        {
          src: require('../../static/img/tsafrat.jpeg'), index: 4
        },
      ],
      descriptions: [
        { description: 'טבעת', index: 1 },
        { description: 'קובעת', index: 2 },
        { description: 'קדרה', index: 3 },
        {
          description: 'צפחת', index: 4
        },
      ],
      activeIndex: null,
      imageIndex: "",
      selectedItemId: null,

    };
  },
  computed: {
    shuffledItems() {
      return this.shuffleArray(this.descriptions);
    },
  },
  methods: {
    checkSelection(element, event) {
      if (element.index == this.imageIndex) {
        console.log("CORRECT")
        event.target.classList.add("greenBorder")
        const activeElement = document.querySelector(".yellowBorder")
        activeElement.classList.remove("yellowBorder")
        activeElement.classList.add("greenBorder")
        var countGreenBorder = document.getElementsByClassName('greenBorder').length;
        console.log("number of green border", countGreenBorder)
        if (countGreenBorder / 2 == this.descriptions.length) {
          console.log("DOOOOOOOOOOOONNNNNNNNNNNE")
        }
      } else {
        console.log("WRONG")
        const activeElement = document.querySelector(".yellowBorder")
        activeElement.classList.remove("yellowBorder")
        activeElement.classList.add("redBorder")
        event.target.classList.add("redBorder")
        setTimeout(() => {
          activeElement.classList.remove("redBorder")
          event.target.classList.remove("redBorder")
        }, 1000);

      }
    },
    selectImage(index, event) {
      event.target.classList.add("yellowBorder")
      this.imageIndex = this.images[index].index
    },
    shuffleArray(array) {
      // Shuffle array using Fisher-Yates algorithm
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
  },
};
</script>

<style scoped>
.greenBorder {
  border: solid rgb(5, 253, 5) 6px !important;
}

.redBorder {
  border: solid rgb(253, 13, 13) 6px !important;
}

.descriptionItems {
  width: 100%;
  height: 135px;
  border: 2px solid grey;
  margin-right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;  
  margin-bottom: 10px;
  font-size: 26px;
  font-family: system-ui;
  color: #504f4f;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

.image-list {
  width: 45%;
}

.image-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.image-list li {
  display: block;
  margin-bottom: 10px;
  cursor: pointer;
}

.yellowBorder {
  border: solid yellow 6px;
}


.image-list li img {
  width: 180px;
  height: auto;
}

.description-lists {
  width: 45%;
  text-align: center;
}

.description-list p {
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  padding: 10px;
}
</style>



